import React, { useEffect, useRef, useState } from 'react';
import { Icon } from './ui';

// The "⋯" button and its small menu (Report, Block, …). items: [{ label, icon, danger, onClick }].
// A tap outside closes it without also tapping whatever is underneath.
function MoreMenu({ items, label = 'More' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const swallow = e => { e.stopPropagation(); e.preventDefault(); };
    const onDown = e => {
      if (ref.current?.contains(e.target)) return;
      setOpen(false);
      document.addEventListener('click', swallow, { capture: true, once: true });
      setTimeout(() => document.removeEventListener('click', swallow, { capture: true }), 700);
    };
    const onKey = e => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('pointerdown', onDown, true);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('pointerdown', onDown, true); document.removeEventListener('keydown', onKey); };
  }, [open]);

  return (
    <div className="bell more-menu" ref={ref}>
      <button className="btn-icon small plain" onClick={() => setOpen(o => !o)} aria-label={label} aria-haspopup="menu" aria-expanded={open}>
        <Icon name="more" />
      </button>
      {open && (
        <div className="bell-menu account-menu more-menu-list" role="menu">
          {items.map(it => (
            <button key={it.label} role="menuitem" className={`account-item ${it.danger ? 'danger' : ''}`} onClick={() => { setOpen(false); it.onClick(); }}>
              {it.icon && <Icon name={it.icon} />}{it.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
export default MoreMenu;
